export default __webpack_public_path__ + "static/media/ic_cart.b422e603.svg";